import { Link } from "react-router-dom";
import { pilotPath } from "../lib/pilots";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { AlertTriangle, RefreshCw, ShieldAlert } from "lucide-react";

// Shown instead of the fiche when the prospect cannot be read (403/404). Says nothing about the prospect itself.
export function ProspectUnavailable({ prospectId, pilotConfirmed }) {
  return (
    <div className="max-w-xl mx-auto" data-testid="prospect-unavailable">
      <Card className="p-8 text-center space-y-3">
        <ShieldAlert className="mx-auto text-slate-300" size={26} />
        <h2 className="font-medium text-slate-900">Fiche inaccessible ou introuvable</h2>
        <p className="text-sm text-slate-500">Cette fiche n'existe pas, ou vous n'y avez pas accès.</p>
        <div className="flex flex-wrap justify-center gap-2 pt-1">
          {pilotConfirmed && (
            <Button asChild data-testid="prospect-unavailable-pilot">
              <Link to={pilotPath(prospectId)}>Ouvrir le pilote</Link>
            </Button>
          )}
          <Button asChild variant="outline" data-testid="prospect-unavailable-pilots"><Link to="/pilotes">Retour aux pilotes</Link></Button>
          <Button asChild variant="outline" data-testid="prospect-unavailable-prospects"><Link to="/prospects">Retour aux prospects</Link></Button>
        </div>
      </Card>
    </div>
  );
}

export function ProspectLoadError({ onRetry }) {
  return (
    <div className="max-w-xl mx-auto" data-testid="prospect-load-error">
      <Card className="p-8 text-center space-y-3">
        <AlertTriangle className="mx-auto text-amber-500" size={22} />
        <h2 className="font-medium text-slate-900">Impossible de charger la fiche</h2>
        <p className="text-sm text-slate-500">Vérifiez votre connexion puis réessayez.</p>
        <Button variant="outline" onClick={onRetry} data-testid="prospect-load-retry"><RefreshCw size={14} className="mr-1.5" />Réessayer</Button>
      </Card>
    </div>
  );
}
